var _ = require('underscore');
var AccordionWidget = require('./../widget/accordion/AccordionWidget');
var estimatedBillsAccordionTemplate = require('./estimatedBillsAccordionTemplate.hbs');
var EstimatedBillsWidget = require('./EstimatedBillsWidget');

/**
 * Displays the estimated bills accordion as a list item.
 *
 * @class EstimatedBillsAccordionWidget
 * @extends Torso.View
 * @constructor
 * @param options {Object}
 *   @param options.appointmentExternalIds {List} the external id of the appointments to get the estimates (via account) for.
 */
module.exports = AccordionWidget.extend({
  template: estimatedBillsAccordionTemplate,

  accordionId: 'estimated-bill-accordion',
  asListItem: true,
  contentNoPadding: true,
  noTriggerView: true,

  prepareFields: _.defaults({
    totalEstimatedBillsAmount: 'getTotalEstimatedBillsAmount',
    estimatedBillsCount: 'getEstimatedBillsCount',
    hasEstimates: 'hasEstimates'
  }, AccordionWidget.prototype.prepareFields),

  initialize: function(options) {
    this._estimatedBillsWidget = new EstimatedBillsWidget({
      appointmentExternalIds: options.appointmentExternalIds
    });
    this.registerTrackedView(this._estimatedBillsWidget);
    this.listenTo(this._estimatedBillsWidget, 'change:totalEstimatedBillsAmount', function() {
      this.trigger('change:totalEstimatedBillsAmount');
    });
    this._accordionContentView = this._estimatedBillsWidget;
  },

  /**
   * @method allEstimatedBillsWithUnapprovedUpdates
   * @returns {boolean} true if all the estimated bills are having unapproved updates
   */
  allEstimatedBillsWithUnapprovedUpdates: function() {
    return this._estimatedBillsWidget && this._estimatedBillsWidget.allEstimatedBillsWithUnapprovedUpdates();
  },

  /**
   * @method getEstimatedBillsCount
   * @returns {Number} the number of estimated bills fetched from the server.  returns 0 if none have been fetched.
   */
  getEstimatedBillsCount: function() {
    return this._estimatedBillsWidget && this._estimatedBillsWidget.getEstimatedBillsCount();
  },

  /**
   * @method getTotalEstimatedBillsAmount
   * @returns {Number} the total amount that the patient has in estimated bills.
   */
  getTotalEstimatedBillsAmount: function() {
    return this._estimatedBillsWidget && this._estimatedBillsWidget.getTotalEstimatedBillsAmount();
  },

  /**
   * @method hasEstimates
   * @return {Boolean} true if the fetched estimated bills exist, false otherwise.
   */
  hasEstimates: function () {
    return this._estimatedBillsWidget && this._estimatedBillsWidget.hasEstimates();
  }
});
